<template>
  <div>
    <vue-good-table mode="remote" @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      :isLoading.sync="table.isLoading" :pagination-options="{
          enabled: false
        }" :columns="table.columns" :rows="table.rows">
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'action'">
          <router-link :to="'/group/edit?id=' + props.row.id">
            <a class="btn btn-primary text-white margin5">Edit</a>
          </router-link>
          <a v-if="props.row.data != 'locked'" v-on:click="deleteContact(props.row.id)" class="btn btn-danger text-white margin5">
            Hapus
          </a>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <!-- Delete confirmation modal -->
    <div v-if="showDeleteModal" class="modal fade show" tabindex="-1" role="dialog" style="display:block; background: rgba(0,0,0,0.5);">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Konfirmasi</h5>
            <button type="button" class="close" aria-label="Close" @click="closeDeleteModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <b style="font-size: 14px;">Apa ingin menghapus juga data nomor pada kontak ?</b>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="performDelete(false)" :disabled="isDeleting">Tidak</button>
            <button type="button" class="btn btn-danger" @click="performDelete(true)" :disabled="isDeleting">
              <span v-if="isDeleting" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
              <span v-if="isDeleting">Menghapus...</span>
              <span v-else>Ya</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-between mt-2">
      <div class="d-flex align-items-center">
        <label class="mr-2 mb-0">Per page</label>
        <select class="form-control form-control-sm w-auto" v-model.number="table.serverParams.limit" @change="onLimitChange">
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
      </div>
      <div class="d-flex align-items-center">
        <span class="text-muted small mr-3" v-if="table.rows && table.rows.length">Showing {{ table.rows.length }} items</span>
        <div class="btn-group" role="group" aria-label="Pagination controls">
          <button
            class="btn btn-sm btn-outline-primary"
            :disabled="cursorStack.length === 0 || table.isLoading"
            @click="goPrevPage"
            title="Go to previous page"
            aria-label="Previous">
            <i class="fas fa-chevron-left"></i>
            <span class="d-none d-sm-inline"> Previous</span>
          </button>
          <button
            class="btn btn-sm btn-outline-primary"
            :disabled="!hasMore || table.isLoading"
            @click="goNextPage"
            title="Go to next page"
            aria-label="Next">
            <span class="d-none d-sm-inline">Next </span>
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        table: {
          isLoading: true,
          columns: [{
              label: "Nama Group",
              field: "name",
              filterOptions: {
                enabled: true,
              },
              sortable: false,
              width: "50%",
            },
            {
              label: "Jumlah Anggota",
              field: "member_count",
              filterOptions: {
                enabled: false,
              },
              sortable: false,
              width: "30%",
            },
            {
              label: "Action",
              field: "action",
              sortable: false,
              width: "20%",
            },
          ],
          rows: [],
          serverParams: {
            columnFilters: {},
            sort: [{
              field: "",
              type: "",
            }, ],
            limit: 10,
            last_id: null,
          },
        },
        hasMore: false,
        cursorStack: [],
        showDeleteModal: false,
        deleteTargetId: null,
        isDeleting: false,
      };
    },
    mounted() {
      this.fn = () => {
        this.loadItems();
      }
      this.$root.$on("refresh_table", this.fn);
      this.loadItems();
    },
    beforeDestroy() {
      this.$root.$off("refresh_table", this.fn);
    },
    methods: {
      async deleteContact(id) {
        this.deleteTargetId = id;
        this.showDeleteModal = true;
      },
      closeDeleteModal() {
        this.showDeleteModal = false;
        this.deleteTargetId = null;
      },
      async performDelete(deleteContact) {
        try {
          this.isDeleting = true;
          let response = await this.$store.dispatch("group_delete", {
            id: this.deleteTargetId,
            deleteContact: !!deleteContact,
          });
          this.closeDeleteModal();
          this.loadItems();
          this.$toast.success(response.data.message);
        } catch (err) {
          this.closeDeleteModal();
          this.$toast.error("Server error");
        } finally {
          this.isDeleting = false;
        }
      },
      updateParams(newProps) {
        this.table.serverParams = Object.assign({},
          this.table.serverParams,
          newProps
        );
      },
      onPageChange() {
        // no-op with cursor pagination
      },
      onPerPageChange() {
        // no-op handled by onLimitChange control below
      },
      onSortChange(params) {
        this.updateParams({
          sort: [{
            type: params.sortType,
            field: this.table.columns[params.columnIndex].field,
          }, ],
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.updateParams(params);
        this.loadItems();
      },
      onLimitChange() {
        this.updateParams({
          limit: this.table.serverParams.limit,
          last_id: null
        });
        this.cursorStack = [];
        this.loadItems();
      },
      goPrevPage() {
        if (this.cursorStack.length > 0) {
          const prevCursor = this.cursorStack.pop();
          this.updateParams({ last_id: prevCursor });
          this.loadItems();
        }
      },
      goNextPage() {
        if (this.hasMore) {
          this.cursorStack.push(this.table.serverParams.last_id);
          const rows = this.table.rows || [];
          const nextCursor = rows.length > 0 ? rows[rows.length - 1].id : null;
          this.updateParams({ last_id: nextCursor });
          this.loadItems();
        }
      },
      async loadItems() {
        this.table.isLoading = true
        try {
          let response = await this.getFromServer(this.table.serverParams);
          const groups = response.data.data.groups;
          this.table.rows = groups;
          this.hasMore = Array.isArray(groups) && groups.length === this.table.serverParams.limit;
        } catch (err) {
          this.$toast.error("Too many request");
        }
        this.table.isLoading = false
      },
      async getFromServer(param) {
        const payload = {
          limit: param.limit,
        };
        if (param.last_id) {
          payload.last_id = param.last_id;
        }
        if (param.columnFilters) {
          payload.columnFilters = param.columnFilters;
        }
        if (param.sort && param.sort.length && param.sort[0].field) {
          payload.sort = param.sort;
        }
        return await this.$store.dispatch("group_list", payload);
      },
    },
  };
</script>

<style scoped>
  .margin5 {
    margin: 5px;
  }
</style>